<template>
  <div class="section-container">
    <!-- Header with Add Button -->
    <b-row align-v="center" class="mb-2">
      <b-col md="12">
        <div class="d-flex justify-content-between align-items-center">
          <h5 class="text-uppercase font-weight-bold mb-0" style="display: flex; align-items: center">
            <i class="fas fa-book mr-2" style="font-size: 20px !important;"></i> Subjects Engaged / Engaging
          </h5>
          <b-button size="sm" variant="info" @click="showAddModal">
            <i class="fas fa-plus mr-1" style="font-size: 12px !important;"></i> Add
          </b-button>
        </div>
      </b-col>
    </b-row>

    <!-- Table -->
    <b-row v-if="subjects && subjects.length > 0" align-v="center" class="mb-3">
      <b-col md="12">
        <table class="table table-striped table-bordered">
          <thead class="thead-dark text-left">
            <tr>
              <th>Sl No.</th>
              <th>Academic Year</th>
              <th>Batch</th>
              <th>Semester</th>
              <th>Subject</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="subject in sortedSubjects" :key="subject.id">
              <td>{{ subject.si_no }}</td>
              <td>{{ subject.academic_year }}</td>
              <td>{{ subject.batch }}</td>
              <td>{{ subject.semester }}</td>
              <td>{{ subject.subject }}</td>
              <td>
                <i class="fas fa-edit pointer text-info" style="font-size: 18px !important;"
                  @click="editSubject(subject)"></i>
                <i class="fas fa-trash fa-sm ml-2" style="cursor: pointer; color: #dc3545;"
                  @click="deleteSubject(subject)"></i>
              </td>
            </tr>
          </tbody>
        </table>
      </b-col>
    </b-row>

    <!-- Modal -->
    <b-modal v-model="showModal" title="Subject" @hide="resetForm" hide-footer>
      <b-form @submit.prevent="createOrUpdateSubject">
        <b-form-group label="Sl No">
          <b-form-input type="number" v-model="subject.si_no"></b-form-input>
        </b-form-group>
        <b-form-group label="Academic Year">
          <b-form-input v-model="subject.academic_year"></b-form-input>
        </b-form-group>
        <b-form-group label="Batch">
          <b-form-input v-model="subject.batch"></b-form-input>
        </b-form-group>
        <b-form-group label="Semester">
          <b-form-input v-model="subject.semester"></b-form-input>
        </b-form-group>
        <b-form-group label="Subject">
          <b-form-input v-model="subject.subject"></b-form-input>
        </b-form-group>
        <b-button type="submit" variant="primary">Save</b-button>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
export default {
  props: ["profile", "profileId"],
  data() {
    return {
      showModal: false,
      editIndex: null,
      subject: { si_no: "", academic_year: "", batch: "", semester: "", subject: "" },
      subjects: this.profile.subjects || [],
    };
  },
  computed: {
    sortedSubjects() {
      return [...this.subjects].sort((a, b) => Number(a.si_no) - Number(b.si_no));
    }
  },
  methods: {
    async createOrUpdateSubject() {
      try {
        const url = this.$store.getters.getAPIKey.mainAPI + `/userprofiles/subjects`;
        let response;

        if (this.editIndex === null) {
          // Create new
          response = await this.$axios.post(url, {
            ...this.subject,
            si_no: Number(this.subject.si_no),
            user_profile_id: this.profile.id,
          });
          this.subjects.unshift(response.data);
        } else {
          // Update existing
          const updateUrl = `${url}/${this.subject.id}`;
          response = await this.$axios.put(updateUrl, {
            ...this.subject,
            si_no: Number(this.subject.si_no),
          });
          this.subjects.splice(this.editIndex, 1, response.data);
        }

        this.$toast.success("Profile Updated", { position: "top", duration: 3000 });
        this.getProfile();
        this.showModal = false;
      } catch (error) {
        console.error("Error updating subject:", error);
        this.$toast.error("Failed to update profile", { position: "top", duration: 3000 });
      }
    },
    async getProfile() {
      try {
        const url = `${this.$store.getters.getAPIKey.mainAPI}/myprofile?profileId=${this.profileId}`;
        const response = await this.$axios.get(url);
        this.profile.subjects = response.data.subjects;
      } catch (error) {
        console.error("Error fetching profile:", error);
      }
    },
    showAddModal() {
      this.resetForm();
      this.showModal = true;
    },
    editSubject(subject) {
      this.subject = { ...subject };
      this.editIndex = this.subjects.findIndex(s => s.id === subject.id);
      this.showModal = true;
    },
    async deleteSubject(subject) {
      try {
        const deleteUrl = `${this.$store.getters.getAPIKey.mainAPI}/userprofiles/subjects/${subject.id}`;
        await this.$axios.delete(deleteUrl);

        const index = this.subjects.findIndex(s => s.id === subject.id);
        if (index !== -1) {
          this.subjects.splice(index, 1);
        }
        this.getProfile();
        this.$toast.success("Subject deleted", { position: "top", duration: 3000 });
      } catch (error) {
        console.error("Error deleting subject:", error);
        this.$toast.error("Failed to delete subject", { position: "top", duration: 3000 });
      }
    },
    resetForm() {
      this.subject = { si_no: "", academic_year: "", batch: "", semester: "", subject: "" };
      this.editIndex = null;
    }
  }
};
</script>

<style scoped>
.section-container {
  padding: 14px;
  background-color: #f9f9f9;
  border-radius: 0px;
  margin-bottom: 20px;
}
</style>
